import styled from '@emotion/styled';
import { CheckmarkIconWhite } from 'icons';

/** SELECT CONTAINER STYLES */
const SelectPopupContainer = styled.div<{ popupContainerPadding?: number[]; popupWidth?: number }>`
  display: flex;
  min-width: 240px;
  max-height: 500px;
  overflow-y: auto;
  border-radius: 4px;
  flex-direction: column;
  padding: ${({ theme }) => theme.space(0.5)};
  background: ${({ theme }) => theme.v2.colours.gray0};
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.12);
  z-index: 99;
  padding: ${({ popupContainerPadding, theme }) =>
    popupContainerPadding ? theme.space(...popupContainerPadding) : theme.space(1, 0.5, 1, 0.5)};
  width: ${({ popupWidth }) => (popupWidth ? `${popupWidth}px` : 'auto')};
`;

const SelectItemSeparator = styled.div`
  height: 1px;
  margin: 4px 0;
  width: 100%;
  background-color: ${({ theme }) => theme.v2.colours.gray100};
`;

const SelectItemContainer = styled.div<{ noHover: boolean; noPadding: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  border-radius: 4px;
  align-items: center;
  cursor: pointer;
  padding: ${({ noPadding, theme }) => (noPadding ? 0 : theme.space(0.5))};

  ${({ noHover, theme }) =>
    !noHover &&
    `
    &:hover {
      background-color: ${theme.v2.colours.gray100};
    }
  `}

  &[data-is-disabled='true'] {
    cursor: default;
    opacity: 0.7;
  }
`;

const CheckboxInput = styled.input<{ checked?: boolean }>`
  /* removing default appearance */
  -webkit-appearance: none;
  appearance: none;
  position: relative;
  width: 16px;
  height: 16px;
  border-radius: 2px;

  border: 1px solid ${({ theme }) => theme.v2.colours.gray500};
  outline: none;
  cursor: pointer;
  margin-right: ${({ theme }) => theme.v2.space(1)};

  &:checked {
    transition: background 0.2s ease-in-out;
    background: ${({ theme }) => theme.v2.colours.latana};
    color: ${({ theme }) => theme.v2.colours.gray0};
    border: none;

    &:before {
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-image: url(${CheckmarkIconWhite});
      background-size: 12px 12px;
      background-repeat: no-repeat;
      background-position: center;
    }
  }
`;

const IconWrapper = styled.div`
  margin-right: ${({ theme }) => theme.v2.space(1)};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LoadingWrapper = styled.div`
  display: flex;
  place-content: center;
`;

export { SelectPopupContainer, SelectItemContainer, CheckboxInput, IconWrapper, SelectItemSeparator, LoadingWrapper };
